import defaultStyle from '../Default'

const homeStyle = {
  ...defaultStyle
}

export default homeStyle
